
import Vue from 'vue'

export default Vue.extend({
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    landscape: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getImageUrl() {
      const imageField = this.landscape ? 'landscape_cover' : 'cover'
      const imageUrl = this.itemData.translations[0][imageField]
      // Conditionally concatenate the base URL if the image URL exists
      return imageUrl ? `${this.$assets}/${imageUrl}` : ''
    }
  }
})
